<h1 mat-dialog-title>Venda</h1>
<div mat-dialog-content class="full-width">  
    <div class="row">
        <div class="col-2">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Id</mat-label>
                <input [(ngModel)]="data.sale.id" matInput readonly>
            </mat-form-field>
        </div>
        <div class="col-10">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Cliente</mat-label>
                <input [(ngModel)]="data.sale.clientName" matInput readonly>
            </mat-form-field>
        </div>  
        
        <div class="col-2">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Valor Total</mat-label>
                <input matInput currencyMask [(ngModel)]="data.sale.amount" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                 matInput readonly>
            </mat-form-field>
        </div>
        <div class="col-2">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Valor Pago</mat-label>
                <input matInput currencyMask [(ngModel)]="data.sale.amountPaid" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                 matInput readonly>
            </mat-form-field>
        </div>          
        <div class="col-2">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Form de Pag</mat-label>
                <input matInput [(ngModel)]="data.sale.payment" matInput readonly>
            </mat-form-field>
        </div>
        <div class="col-2">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Valor Pago 2</mat-label>
                <input matInput currencyMask [(ngModel)]="data.sale.amountPaidTwo" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                 matInput readonly>
            </mat-form-field>
        </div>          
        <div class="col-2">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Form de Pag 2</mat-label>
                <input matInput [(ngModel)]="data.sale.paymentTwo" matInput readonly>
            </mat-form-field>
        </div> 
        <div class="col-2">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Troco</mat-label>
                <input matInput currencyMask [(ngModel)]="data.sale.difference" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                 matInput readonly>
            </mat-form-field>
        </div> 
        <div class="col-12">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Observação</mat-label>
                <textarea  [(ngModel)]="data.sale.observation" matInput readonly></textarea>
            </mat-form-field>                             
        </div> 
        
        
    </div>

    <div class="full-width">
        <section class="tabel-container mat-elevation-z8" tabindex="0">
            <table mat-table [dataSource]="productsSolds" class="full-width">
                <!-- Coluna quantidade -->
                <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef> Quantidade </th>
                    <td mat-cell *matCellDef="let productSold"> {{ productSold.quantity }} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <!-- Coluna Nome -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Nome </th>
                    <td mat-cell *matCellDef="let productSold"> {{ productSold.product.name }} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <!-- Coluna preco -->
                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef>Preço</th>
                    <td mat-cell *matCellDef="let productSold"> {{ productSold.price | currency:'BRL'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="desconto">
                    <th mat-header-cell *matHeaderCellDef>Desconto</th>
                    <td mat-cell *matCellDef="let productSold"> {{ productSold.desconto |
                        currency:'BRL'}}
                    </td>
                </ng-container>
                <!-- Coluna preco total -->
                <ng-container matColumnDef="priceTotal">
                    <th mat-header-cell *matHeaderCellDef>Total</th>
                    <td mat-cell *matCellDef="let productSold"> {{ productSold.priceTotal |
                        currency:'BRL'}}
                    </td>
                </ng-container>
                <!-- definir como vai ser as linhas e a ordem das colunas -->
                <tr mat-header-row *matHeaderRowDef="ordemColunasTabela; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
            </table>
        </section>       
    </div>
</div>
